import { createAsyncThunk } from '@reduxjs/toolkit'
import { deserialize, serialize } from '../utility/serialization'

import Axios from '../axios'
import { handleAPIError } from '../utility/actionHelper'

export const getMembershipPlans = createAsyncThunk(
  'membership/getMembershipPlans',
  async ({ communityId }, { rejectWithValue }) => {
    try {
      const { data } = await requestMembershipPlans(communityId)
      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const getCurrentMembership = createAsyncThunk(
  'membership/getCurrentMembership',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await requestCurrentMembership()
      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

function requestMembershipPlans(communityId) {
  const requestUrl = '/api/v1/memberships/plans'

  return Axios.get(requestUrl, { params: serialize({ communityId }) })
}

function requestCurrentMembership() {
  const requestUrl = '/api/v1/memberships/current'

  return Axios.get(requestUrl)
}
